import React, { useEffect, useState } from "react";
import { AssetType, useGetAssetsQuery } from "../store/slices/mapsSlice";
import { Form } from "react-bootstrap";
import EditAssetModal from "./EditAssetModal";
import PageHeader from "../Common/PageHeader";
import Subheading from "../Common/Subheading";
import WhiteButton from "../Common/WhiteButton";
import MyPagination from "../Common/MyPagination";
import AssetList from "./AssetList";
import AssetsIconSVG from "../../assets/icons/asset-01.svg2";
import AssetsLinks from "./AssetsLinks";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { useNavigate, useParams } from "react-router-dom";
import {
  formatAssetKindOptionLabel,
  getAssetKindValueLabels,
  loadAssetKindOptions,
} from "./assetIconsList";
import HelpButton from "../HelpContent/HelpButton";

const newAsset: Partial<AssetType> = {
  Label: "",
  ClientId: 0,
  Kind: "asset",
  HasLocation: false,
  HasManyLocations: false,
  CanMove: false,
  HasLocationHistory: false,
  Locations: [],
  ParentAssets: [],
  ChildAssets: [],
  AssetContacts: [],
};

export default function Assets() {
  const [search, setSearch] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [pagination, setPagination] = useState({
    page: 0,
    perPage: 10,
    search: "new",
    kind: "",
    hasLocation: false,
    hasContacts: false,
  });

  useEffect(() => {
    const t = setTimeout(() => {
      setPagination((p) => ({ ...p, search }));
    }, 500);
    return () => {
      clearTimeout(t);
    };
  }, [search]);

  const {
    data: { assets, total } = { assets: [], total: 0 },
    isLoading,
    error,
  } = useGetAssetsQuery(pagination);

  const { assetUUID } = useParams();
  const navigate = useNavigate();

  return (
    <div className="mb-5">
      <div className="d-flex justify-content-between align-items-start">
        <div className="d-flex  align-items-center">
          <Subheading
            Icon={AssetsIconSVG}
            heading="Manage Assets"
            subheading="Add edit and control your companies Assets."
          />
        </div>
        <div className="d-flex flex-wrap gap-2 mb-3">
          <WhiteButton
            as="RRLink"
            to="/assets/assets/new"
            icon={AssetsIconSVG}
            heading="Add"
            subheading="Asset"
            target={undefined}
            disabled={false}
          />
        </div>
      </div>
      <div className="d-flex gap-5 align-items-end mb-3 bg-colored-reverse p-3 m-0 rounded-3 ">
        <div>
          <label className="form-label text-nowrap fw-bold text-white p-2">
            Select asset type
          </label>
          <Input
            value={[pagination.kind || "Select asset type"]}
            onChange={([v]: any) => {
              setPagination((p) => ({ ...p, kind: v }));
            }}
            inputType="select"
            options={undefined}
            loadOptions={loadAssetKindOptions as any}
            formatOptionLabel={formatAssetKindOptionLabel}
            getValueLabels={getAssetKindValueLabels as any}
            isClearable
          />
        </div>
        <div className="text-white fw-bold">
          <Form.Check
            type="checkbox"
            label="Has Location"
            id="has-location"
            checked={pagination.hasLocation}
            onChange={(e) =>
              setPagination((p) => ({
                ...p,
                hasLocation: e.target.checked,
              }))
            }
          />
        </div>
        <div className="text-white fw-bold">
          <Form.Check
            type="checkbox"
            label="Has Contacts"
            id="has-contacts"
            checked={pagination.hasContacts}
            onChange={(e) =>
              setPagination((p) => ({
                ...p,
                hasContacts: e.target.checked,
              }))
            }
          />
        </div>
        <div className="text-white fw-bold">
          <Form.Check
            type="checkbox"
            label="Show as Table"
            id="show-as-table"
            checked={showTable}
            onChange={(e) => setShowTable(e.target.checked)}
          />
        </div>
        <div className="ms-auto" style={{ minWidth: "250px" }}>
          <Form.Control
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search assets by label"
          />
        </div>
      </div>
      <div className="p-3 rounded-3 bg-white my-3">
        {total === 0 ? (
          <div className="alert alert-warning">No assets found.</div>
        ) : (
          <AssetList assets={assets} showTable={showTable} />
        )}
        <MyPagination
          onPaginate={(page: number, perPage: number) =>
            setPagination((p) => ({ ...p, page, perPage }))
          }
          total={total}
        />
      </div>
      {assetUUID && (
        <EditAssetModal
          key={assetUUID}
          assetUuid={assetUUID}
          onClose={() => navigate(-1)}
          forceShow
        />
      )}
    </div>
  );
}
